(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aube-benefits-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aube-benefit-carousel')) {
    customElements.define('aube-benefit-carousel', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.cards = Array.from(this.querySelectorAll('[data-card-id]'));
        this.dots = Array.from(this.querySelectorAll('[data-card-index]'));
        this.arrows = Array.from(this.querySelectorAll('[data-direction]'));
        this.navigation = this.querySelector('[data-navigation]');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const moveTo = (left) => this.track.scrollTo({ left, behavior: reduced.matches ? 'instant' : 'smooth' });
        const position = (index) => this.cards[index].offsetLeft - this.cards[0].offsetLeft;
        const update = () => {
          const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          this.navigation.hidden = max < 2;
          let index = 0;
          if (max > 2 && this.track.scrollLeft >= max - 2) index = this.cards.length - 1;
          else this.cards.forEach((card, i) => { if (Math.abs(position(i) - this.track.scrollLeft) < Math.abs(position(index) - this.track.scrollLeft)) index = i; });
          this.dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
          this.arrows[0].disabled = this.track.scrollLeft < 2;
          this.arrows[1].disabled = this.track.scrollLeft >= max - 2;
        };
        this.dots.forEach(dot => dot.addEventListener('click', () => moveTo(position(Number(dot.dataset.cardIndex))), { signal }));
        this.arrows.forEach(button => button.addEventListener('click', () => {
          const step = this.cards.length > 1 ? position(1) : this.track.clientWidth;
          moveTo(this.track.scrollLeft + Number(button.dataset.direction) * step);
        }, { signal }));
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.cardId === event.detail.blockId);
          if (index >= 0) moveTo(position(index));
        }, { signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aube-dawn-timeline"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aube-dawn-timeline')) {
  customElements.define('aube-dawn-timeline', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      this.scene = this.querySelector('[data-dawn-scene]');
      this.pin = this.querySelector('[data-pin]');
      this.media = this.querySelector('[data-dawn-visual]');
      this.video = this.querySelector('[data-dawn-video]');
      this.phase = this.querySelector('[data-phase]');
      this.followers = Array.from(this.querySelectorAll('[data-follow-step]'));
      if (!this.scene || !this.pin || !this.media || !this.video || !this.phase) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.enabled = this.dataset.animate === 'true';
      this.ready = this.loading = this.failed = this.seeking = false;
      this.near = this.inRange = false;
      this.updateFrame = this.measureFrame = this.seekFrame = 0;
      this.progress = this.targetTime = this.distance = this.lastSeekAt = 0;
      this.lastRequestedTime = -1;
      this.classList.remove('is-rendered');
      this.dataset.videoState = 'idle';
      this.video.muted = this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.pageReady = document.readyState === 'complete';
      this.schedule = () => {
        if (!this.inRange || document.hidden || this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => { this.updateFrame = 0; this.update(); });
      };
      window.addEventListener('scroll', this.schedule, { passive:true, signal });
      window.addEventListener('resize', () => this.scheduleMeasure(), { passive:true, signal });
      window.addEventListener('load', () => { this.pageReady = true; this.loadWhenIdle(); }, { once:true, signal });
      window.addEventListener('pageshow', () => this.scheduleMeasure(), { signal });
      const preferenceChanged = () => {
        if (this.staticMode()) { this.releaseVideo(); this.dataset.videoState = 'static'; }
        this.measure();
        this.loadWhenIdle();
      };
      this.motion.addEventListener('change', preferenceChanged, { signal });
      this.connection?.addEventListener('change', preferenceChanged, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          cancelAnimationFrame(this.seekFrame);
          this.seekFrame = 0;
          clearTimeout(this.watchdog);
          this.video.pause();
        } else {
          this.seeking = this.video.seeking;
          if (this.loading && !this.ready || this.seeking) this.watch();
          this.update();
          this.loadWhenIdle();
        }
      }, { signal });
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.scheduleMeasure());
        this.resizeObserver.observe(this.pin);
      }
      if (window.IntersectionObserver) {
        this.intersection = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target === this) this.inRange = entry.isIntersecting;
            if (entry.target === this.scene) this.near = entry.isIntersecting;
          }
          if (!this.near) {
            cancelAnimationFrame(this.seekFrame);
            this.seekFrame = 0;
            if (this.seeking) clearTimeout(this.watchdog);
          } else if (this.seeking) {
            this.seeking = this.video.seeking;
            if (this.seeking) this.watch();
          }
          this.loadWhenIdle();
          this.schedule();
        }, { rootMargin:'300px 0px' });
        this.intersection.observe(this);
        this.intersection.observe(this.scene);
      } else this.failed = true;
      const ready = () => {
        if (this.failed || !this.loading || this.video.readyState < 2 || !Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
        this.ready = true;
        clearTimeout(this.watchdog);
        this.dataset.videoState = 'ready';
        this.update();
      };
      this.video.addEventListener('loadeddata', ready, { signal });
      this.video.addEventListener('canplay', ready, { signal });
      this.video.addEventListener('seeked', () => {
        this.seeking = false;
        clearTimeout(this.watchdog);
        if (this.ready && !this.staticMode()) this.reveal();
        this.scheduleSeek();
      }, { signal });
      this.video.addEventListener('error', () => { if (this.loading) this.fail(); }, { signal });
      document.fonts?.ready.then(() => { if (!signal.aborted) this.scheduleMeasure(); });
      this.measure();
    }
    staticMode() {
      return !this.enabled || this.motion.matches || Boolean(this.connection?.saveData);
    }
    scheduleMeasure() {
      if (!this.isConnected || this.measureFrame) return;
      this.measureFrame = requestAnimationFrame(() => { this.measureFrame = 0; this.measure(); });
    }
    measure() {
      if (!this.isConnected) return;
      const viewport = window.innerHeight;
      const rootStyle = getComputedStyle(document.documentElement);
      const header = Math.max(60, parseFloat(rootStyle.getPropertyValue('--header-height')) || 0);
      const minTop = header + 16;
      const bottom = 80;
      const nonMedia = this.pin.offsetHeight - this.media.offsetHeight;
      const natural = Math.min(this.media.parentElement.clientWidth / (Number(this.dataset.aspect) || 1), 500);
      const mediaHeight = Math.max(150, Math.floor(Math.min(natural, viewport - minTop - bottom - nonMedia)));
      this.style.setProperty('--at-media-height', mediaHeight + 'px');
      const height = this.pin.offsetHeight;
      const canPin = !this.staticMode() && !this.failed && viewport - minTop - bottom + 1 >= height;
      this.classList.toggle('is-pinned', Boolean(canPin));
      this.top = Math.max(minTop, (viewport - bottom - height + minTop) / 2);
      this.distance = canPin ? Math.max(320, viewport * (Number(this.dataset.distance) || 120) / 100) : 0;
      this.style.setProperty('--at-pin-top', this.top + 'px');
      this.style.setProperty('--at-scene-height', height + this.distance + 'px');
      this.update();
      this.loadWhenIdle();
    }
    loadWhenIdle() {
      if (!this.isConnected || !this.pageReady || !this.distance || !this.near || document.hidden || this.staticMode() || this.loading || this.failed || this.idlePending) return;
      this.idlePending = true;
      const load = () => { this.idlePending = false; this.idleId = 0; this.loadVideo(); };
      this.idleIsNative = Boolean(window.requestIdleCallback);
      this.idleId = this.idleIsNative ? window.requestIdleCallback(load, { timeout:800 }) : setTimeout(load, 100);
    }
    loadVideo() {
      if (!this.isConnected || !this.distance || !this.near || document.hidden || this.staticMode() || this.loading || this.failed) return;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const source = mobile ? this.dataset.videoMobile || this.dataset.videoDesktop : this.dataset.videoDesktop || this.dataset.videoMobile;
      if (!source) { this.fail(); return; }
      this.loading = true;
      this.dataset.videoState = 'loading';
      this.video.preload = 'auto';
      this.video.src = source;
      this.video.load();
      this.watch();
    }
    watch() {
      clearTimeout(this.watchdog);
      this.watchdog = setTimeout(() => { if (this.isConnected && !document.hidden) this.fail(); }, 20000);
    }
    scheduleSeek() {
      if (!this.ready || this.failed || this.seeking || this.seekFrame || !this.near || document.hidden || this.staticMode()) return;
      this.seekFrame = requestAnimationFrame(now => {
        this.seekFrame = 0;
        if (now - this.lastSeekAt < 1000 / 30) { this.scheduleSeek(); return; }
        this.seek(now);
      });
    }
    seek(now) {
      if (!this.isConnected || !this.ready || this.video.seeking || !this.near || document.hidden || this.staticMode()) return;
      const end = Math.max(0, this.video.duration - 1 / 30);
      const desired = Math.min(end, Math.max(0, Math.round(this.progress * end * 30) / 30));
      this.targetTime = desired;
      this.dataset.targetTime = desired.toFixed(3);
      if (desired === this.lastRequestedTime || Math.abs(desired - this.video.currentTime) < 1 / 60) { this.reveal(); return; }
      this.lastSeekAt = now;
      this.lastRequestedTime = desired;
      this.seeking = true;
      this.watch();
      try { this.video.currentTime = desired; } catch { this.fail(); }
    }
    reveal() {
      if (this.video.readyState < 2 || this.failed || this.staticMode()) return;
      this.classList.add('is-rendered');
      this.dataset.currentTime = this.video.currentTime.toFixed(3);
    }
    update() {
      if (!this.scene || !this.isConnected || document.hidden) return;
      const rect = this.scene.getBoundingClientRect();
      const active = this.classList.contains('is-pinned');
      const progress = active ? Math.max(0, Math.min(1, (this.top - rect.top) / this.distance)) : 1;
      this.progress = progress;
      this.dataset.progress = progress.toFixed(3);
      this.scheduleSeek();
      this.pin.style.setProperty('--at-progress', String(progress));
      this.pin.style.setProperty('--at-marker-y', this.pin.offsetHeight * progress + 'px');
      const label = progress < .34 ? this.dataset.startLabel : progress < .78 ? this.dataset.middleLabel : this.dataset.endLabel;
      if (this.phase.textContent !== label) this.phase.textContent = label;
      const guide = window.innerHeight * .58;
      this.followers.forEach(step => {
        const bounds = step.getBoundingClientRect();
        step.classList.toggle('is-reached', bounds.top + 17 <= guide);
        step.style.setProperty('--at-progress', String(Math.max(0, Math.min(1, (guide - bounds.top - 17) / Math.max(1, bounds.height - 17)))));
      });
    }
    releaseVideo() {
      cancelAnimationFrame(this.seekFrame);
      this.seekFrame = 0;
      clearTimeout(this.watchdog);
      if (this.idleIsNative) window.cancelIdleCallback(this.idleId); else clearTimeout(this.idleId);
      this.idlePending = false;
      this.loading = this.ready = this.seeking = false;
      this.lastRequestedTime = -1;
      this.classList.remove('is-rendered');
      this.video?.pause();
      if (this.video?.hasAttribute('src')) { this.video.removeAttribute('src'); this.video.load(); }
    }
    fail() {
      this.failed = true;
      this.releaseVideo();
      this.dataset.videoState = 'failed';
      this.measure();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      cancelAnimationFrame(this.updateFrame);
      cancelAnimationFrame(this.measureFrame);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.intersection?.disconnect();
      this.releaseVideo();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aube-details-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aube-detail-carousel')) {
    customElements.define('aube-detail-carousel', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.cards = Array.from(this.querySelectorAll('[data-card-id]'));
        this.dots = Array.from(this.querySelectorAll('[data-card-index]'));
        this.arrows = Array.from(this.querySelectorAll('[data-direction]'));
        this.stage = this.querySelector('.aube-details__stage');
        this.firstImage = this.querySelector('.aube-details__image');
        this.navigation = this.querySelector('[data-navigation]');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const moveTo = (left) => this.track.scrollTo({ left, behavior: reduced.matches ? 'instant' : 'smooth' });
        const position = (index) => this.cards[index].offsetLeft - this.cards[0].offsetLeft;
        const update = () => {
          if (this.firstImage) this.stage.style.setProperty('--aube-details-image-height', `${this.firstImage.getBoundingClientRect().height}px`);
          const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          this.navigation.hidden = max < 2;
          let index = 0;
          if (max > 2 && this.track.scrollLeft >= max - 2) index = this.cards.length - 1;
          else this.cards.forEach((card, i) => { if (Math.abs(position(i) - this.track.scrollLeft) < Math.abs(position(index) - this.track.scrollLeft)) index = i; });
          this.dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
          this.arrows[0].disabled = this.track.scrollLeft < 2;
          this.arrows[1].disabled = this.track.scrollLeft >= max - 2;
        };
        this.dots.forEach(dot => dot.addEventListener('click', () => moveTo(position(Number(dot.dataset.cardIndex))), { signal }));
        this.arrows.forEach(button => button.addEventListener('click', () => {
          const step = this.cards.length > 1 ? position(1) : this.track.clientWidth;
          moveTo(this.track.scrollLeft + Number(button.dataset.direction) * step);
        }, { signal }));
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const step = this.cards.length > 1 ? position(1) : this.track.clientWidth;
          let left;
          if (event.key === 'ArrowRight') left = this.track.scrollLeft + step;
          else if (event.key === 'ArrowLeft') left = this.track.scrollLeft - step;
          else if (event.key === 'Home') left = 0;
          else if (event.key === 'End') left = this.track.scrollWidth;
          else return;
          event.preventDefault();
          moveTo(left);
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.cardId === event.detail.blockId);
          if (index >= 0) moveTo(position(index));
        }, { signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        if (this.firstImage) this.observer.observe(this.firstImage);
        update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aube-reviews-ai"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aube-reviews-ai')) {
    customElements.define('aube-reviews-ai', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.setAttribute('data-enhanced', '');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.track = this.querySelector('[data-track]');
        this.cards = [...this.querySelectorAll('[data-review]')];
        this.summary = this.querySelector('[data-summary]');
        this.navigation = this.querySelector('[data-navigation]');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.progress = this.querySelector('[data-progress]');
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-read-more]');
          if (!button || !this.contains(button)) return;
          const text = button.closest('[data-review]').querySelector('[data-review-text]');
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          text.toggleAttribute('data-expanded', expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.less : button.dataset.more;
        }, { signal });
        this.previous?.addEventListener('click', () => this.move(-1), { signal });
        this.next?.addEventListener('click', () => this.move(1), { signal });
        this.track?.addEventListener('scroll', () => this.updateNavigation(), { signal, passive: true });
        this.track?.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        this.resize = new ResizeObserver(() => this.measure());
        this.resize.observe(this);
        document.fonts?.ready.then(() => { if (this.isConnected) this.measure(); });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          if (this.summary?.contains(event.target) || event.target === this.summary) this.reveal();
          const card = event.target.closest('[data-review]');
          if (card && this.track) this.scrollToCard(card);
        }, { signal });
        this.motion.addEventListener('change', event => { if (event.matches) this.reveal(); }, { signal });
        this.prepareSummary();
        this.measure();
      }
      measure() {
        this.cards.forEach(card => {
          const text = card.querySelector('[data-review-text]');
          const button = card.querySelector('[data-read-more]');
          const expanded = text.hasAttribute('data-expanded');
          if (expanded) text.removeAttribute('data-expanded');
          const overflows = text.scrollHeight > text.clientHeight + 1;
          if (expanded) text.setAttribute('data-expanded', '');
          button.hidden = !overflows && !expanded;
        });
        this.updateNavigation();
      }
      updateNavigation() {
        if (!this.track || !this.navigation) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const offset = Math.abs(this.track.scrollLeft);
        this.navigation.hidden = max <= 2;
        this.previous.disabled = offset <= 2;
        this.next.disabled = offset >= max - 2;
        const visible = this.track.clientWidth / this.track.scrollWidth;
        this.progress.style.width = `${Math.min(100, (visible + (max > 0 ? offset / max : 0) * (1 - visible)) * 100)}%`;
      }
      move(direction) {
        if (!this.track || !this.cards.length) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: step * direction * rtl, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      scrollToCard(card) {
        const trackRect = this.track.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        this.track.scrollBy({ left: cardRect.left - trackRect.left, behavior: 'instant' });
      }
      prepareSummary() {
        if (!this.summary) return;
        if (this.summary.dataset.played === 'true' || this.summary.dataset.animate !== 'true' || this.motion.matches || !('IntersectionObserver' in window)) {
          this.reveal();
          return;
        }
        this.summary.dataset.state = 'waiting';
        this.summary.querySelector('[data-loading]').hidden = false;
        this.summary.querySelector('[data-summary-content]').inert = true;
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.summary.dataset.state = 'loading';
          this.summary.setAttribute('aria-busy', 'true');
          const status = this.summary.querySelector('[data-status]');
          status.textContent = status.dataset.loadingLabel;
          this.timer = window.setTimeout(() => this.typeSummary(), Math.max(0, Number(this.summary.dataset.duration) || 0));
        }, { threshold: .1 });
        this.observer.observe(this.summary);
      }
      typeSummary() {
        if (!this.isConnected || !this.summary) return;
        if (this.motion.matches || this.summary.dataset.typewriter === 'false') {
          this.reveal(true);
          return;
        }
        const source = this.summary.querySelector('[data-summary-text]');
        if (!source?.textContent.trim()) {
          this.reveal(true);
          return;
        }
        const copy = source.cloneNode(true);
        copy.removeAttribute('data-summary-text');
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        copy.querySelectorAll('p, ul, ol, li, blockquote, div, h1, h2, h3, h4, h5, h6').forEach(element => element.setAttribute('data-pending-text', ''));
        const segmenter = typeof Intl.Segmenter === 'function' ? new Intl.Segmenter(undefined, { granularity: 'grapheme' }) : null;
        const walker = document.createTreeWalker(copy, NodeFilter.SHOW_TEXT);
        const parts = [];
        let node;
        while ((node = walker.nextNode())) {
          if (!node.data.trim()) continue;
          const letters = segmenter ? Array.from(segmenter.segment(node.data), part => part.segment) : Array.from(node.data);
          parts.push({ node, letters });
        }
        const total = parts.reduce((count, part) => count + part.letters.length, 0);
        if (!total) {
          this.reveal(true);
          return;
        }
        const batchSize = Math.max(1, Math.ceil(total / 90));
        const steps = [];
        for (const part of parts) {
          part.node.data = '';
          let end = 0;
          while (end < part.letters.length) {
            end = Math.min(part.letters.length, end + Math.max(1, Math.round(batchSize * (.55 + Math.random() * 1.15))));
            const text = part.letters.slice(0, end).join('');
            const pause = /[.!?;:,…]\s*$/u.test(text) ? 1.8 : 1;
            steps.push({ node: part.node, text, weight: (.65 + Math.random() * .9) * pause });
          }
        }
        const duration = Math.min(3600, Math.max(450, total * 7));
        const weight = steps.reduce((sum, step) => sum + step.weight, 0);
        let elapsed = 0;
        for (const step of steps) {
          elapsed += duration * step.weight / weight;
          step.at = elapsed;
        }
        const body = this.summary.querySelector('.aube-reviews__summary-body');
        this.typingMinHeight = body.getBoundingClientRect().height;
        body.style.height = `${this.typingMinHeight}px`;
        body.setAttribute('data-resizing', '');
        this.typingLayer = document.createElement('div');
        this.typingLayer.className = 'aube-reviews__summary-content aube-reviews__typing';
        this.typingLayer.setAttribute('aria-hidden', 'true');
        this.typingLayer.inert = true;
        this.typingLayer.append(copy);
        body.append(this.typingLayer);
        this.summary.dataset.state = 'typing';
        this.summary.querySelector('[data-loading]').hidden = true;
        this.summaryResize = new ResizeObserver(() => this.updateSummaryHeight());
        this.summaryResize.observe(this.typingLayer);
        const startedAt = performance.now();
        let index = 0;
        const advance = () => {
          if (!this.isConnected || this.motion.matches) {
            this.reveal(true);
            return;
          }
          const now = performance.now() - startedAt;
          while (index < steps.length && steps[index].at <= now) {
            const step = steps[index++];
            step.node.data = step.text;
            let parent = step.node.parentElement;
            while (parent && parent !== copy) {
              parent.removeAttribute('data-pending-text');
              parent = parent.parentElement;
            }
          }
          this.updateSummaryHeight();
          if (index === steps.length) {
            this.reveal(true);
            return;
          }
          this.typingTimer = window.setTimeout(advance, Math.max(8, steps[index].at - now));
        };
        advance();
      }
      updateSummaryHeight() {
        if (!this.typingLayer) return;
        const height = Math.max(this.typingMinHeight, Math.ceil(this.typingLayer.getBoundingClientRect().height));
        this.summary.querySelector('.aube-reviews__summary-body').style.height = `${height}px`;
      }
      reveal(announce = false) {
        if (!this.summary) return;
        window.clearTimeout(this.timer);
        window.clearTimeout(this.typingTimer);
        window.clearTimeout(this.heightTimer);
        this.summaryResize?.disconnect();
        this.typingLayer?.remove();
        this.typingLayer = null;
        this.observer?.disconnect();
        this.summary.dataset.played = 'true';
        this.summary.dataset.state = 'ready';
        this.summary.setAttribute('aria-busy', 'false');
        this.summary.querySelector('[data-summary-content]').inert = false;
        this.summary.querySelector('[data-loading]').hidden = true;
        const body = this.summary.querySelector('.aube-reviews__summary-body');
        const resetHeight = () => {
          body.style.removeProperty('height');
          body.removeAttribute('data-resizing');
        };
        if (body.style.height && this.isConnected && !this.motion.matches && announce) {
          body.style.height = `${Math.ceil(this.summary.querySelector('[data-summary-content]').getBoundingClientRect().height)}px`;
          this.heightTimer = window.setTimeout(resetHeight, 200);
        } else {
          resetHeight();
        }
        const status = this.summary.querySelector('[data-status]');
        status.textContent = announce ? status.dataset.readyLabel : '';
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
        window.clearTimeout(this.timer);
        this.reveal();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
